/**
 * @generated SignedSource<<c2c0e190a25e49e1edda73a48fc5663c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OtherDocuments_documentLabels$data = {
  readonly allDocumentLabelsTitle: string | null | undefined;
  readonly documentLabelsTitle: string | null | undefined;
  readonly furtherDocumentLabelsTitle: string | null | undefined;
  readonly labels: ReadonlyArray<{
    readonly key: string | null | undefined;
    readonly label: string | null | undefined;
    readonly shortlabel: string | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "OtherDocuments_documentLabels";
};
export type OtherDocuments_documentLabels$key = {
  readonly " $data"?: OtherDocuments_documentLabels$data;
  readonly " $fragmentSpreads": FragmentRefs<"OtherDocuments_documentLabels">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OtherDocuments_documentLabels",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DocumentLabel",
      "kind": "LinkedField",
      "name": "labels",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "shortlabel",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "documentLabelsTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "furtherDocumentLabelsTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allDocumentLabelsTitle",
      "storageKey": null
    }
  ],
  "type": "DocumentLabels",
  "abstractKey": null
};

(node as any).hash = "bc28df4b698807eecdc862d61345d8f3";

export default node;
